module.exports = __webpack_public_path__ + "static/media/PM_foundation.4d934dd4.svg";